module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAAJFBMVEUAAAD/AFb/AFb/AFX/AFP/AFX/AFX/AFb/AF3/AFX/AFP/AFWJ56jMAAAAC3RSTlMAMO+/QM+PgBDfIEgAvP4AAAC5SURBVCjPYxiqQNxo9+QSdEHh3SBggirIthsCMpAFOaKholsbkERbd8NAAJJoNlx0G0KQZTcCCMBFmZFEDeCi3kDeEu3dm6SA9Ea4aDVIp9BuRZBJ2+Gi1kCeIqOSgBCQ3gwXnQ3kbRIQZNQG0XBRsDWKDEJgmoCoNpIJO3HahnCZgxBQAsVl0kDeQqAvvID0FgI+ZkQSdSAQkgyscNEIgjHE0AYVTUCNZGewoCF6gnC33K1cyDBEAQBXEKedcNPjDAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/modal_close.png
// module id = 5NpB
// module chunks = 23